import React from 'react'

const ExternoRoutes = () => {
  return (
    <div>
      
    </div>
  )
}

export default ExternoRoutes
